import { render } from "./ParcelInfo.vue?vue&type=template&id=077fe4a2&scoped=true"
import script from "./ParcelInfo.vue?vue&type=script&lang=js"
export * from "./ParcelInfo.vue?vue&type=script&lang=js"

import "./ParcelInfo.vue?vue&type=style&index=0&id=077fe4a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-077fe4a2"]])

export default __exports__